import { useState, useEffect, useCallback } from "react";

type SidebarCounts = {
  leads: number;
  appointments: number;
  followUps: number;
};

export function useSidebarCounts() {
  const [counts, setCounts] = useState<SidebarCounts | null>(null);

  const fetchCounts = useCallback(() => {
    fetch("/api/sidebar/counts")
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data) setCounts(data);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    fetchCounts();

    const interval = setInterval(fetchCounts, 60_000);

    const onRoleChanged = () => fetchCounts();
    window.addEventListener("dev-role-changed", onRoleChanged);

    return () => {
      clearInterval(interval);
      window.removeEventListener("dev-role-changed", onRoleChanged);
    };
  }, [fetchCounts]);

  return counts;
}
